import classNames from "classnames";
import Link from "next/link";

import { Action, Category } from "@/constants/events";
import { useDispatch } from "@/redux/hooks";
import { REQUEST_LOCATION } from "@/redux/reducers/location";
import { trackEvent } from "@/utils/trackEvent";

import NotFoundIcon from "@/components/Icons/not_found.svg";

const DealsPromosNoResults: React.FC<{ className?: string; type: string }> = ({
  className,
  type,
}) => {
  const dispatch = useDispatch();

  const onChangeLocation = () => {
    trackEvent(Category.button, Action.click, "change your location");
    dispatch({ type: REQUEST_LOCATION });
  };

  return (
    <div
      className={classNames(
        className,
        "border border-light-grey rounded flex justify-center items-center p-lg",
      )}
    >
      <div className="text-center">
        <NotFoundIcon className="mx-auto mb-sm" width={48} />
        <p className="font-bold text-center">
          There are no {type} near this location right now
        </p>
        <p className="text-xs">
          You can learn about{" "}
          <Link href="/strains/lists" className="underline">
            cannabis strains
          </Link>
          ,{" "}
          <Link href="/dispensaries" className="underline">
            find dispensaries near you
          </Link>{" "}
          or{" "}
          <button className="underline" onClick={onChangeLocation}>
            change your location
          </button>
          .
        </p>
      </div>
    </div>
  );
};

export default DealsPromosNoResults;
